module.exports = __webpack_public_path__ + "files/a1f69632e02bfe6259b2ef40ff12b8aa.png";